/**
 * @graphql cc
 */
import { useQueryInterop } from '@confluence/apollo-relay-interop';
import { graphql } from 'react-relay';

import type {
	usePreloadCommentButtonQuery$data,
	usePreloadCommentButtonQuery$variables,
} from './__generated__/usePreloadCommentButtonQuery.graphql.ts';

const usePreloadCommentButtonQuery = graphql`
	query usePreloadCommentButtonQuery($pageId: ID!) {
		comments(pageId: $pageId, type: UNRESOLVED, depth: ALL) {
			count
			nodes {
				id
				location {
					type
					... on InlineComment {
						inlineMarkerRef
					}
				}
			}
		}
		content(id: $pageId) {
			nodes {
				id
				properties(key: "editor") {
					nodes {
						id
						key
						value
					}
				}
				metadata {
					frontend {
						fabricEditorSupported
					}
				}
			}
		}
	}
`;

export const usePreloadCommentButton = (contentId: string, isCommentButtonSSRd: boolean) => {
	const { data: commentData, error: commentError } = useQueryInterop<
		usePreloadCommentButtonQuery$data,
		usePreloadCommentButtonQuery$variables
	>(usePreloadCommentButtonQuery, {
		fetchPolicy: isCommentButtonSSRd ? 'cache-first' : 'cache-and-network',
		variables: { pageId: contentId },
	});

	return {
		data: { commentData },
		error: commentError,
	};
};
